//引入axios
import axios from "axios";
import vue   from   'vue'

const $axios = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? '/api' : "http://localhost:8081",
  timeout: 10000
});

// 请求拦截器
$axios.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.token = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器
$axios.interceptors.response.use(
  (response) => {
    return response.data; // 直接返回 data
  },
  (error) => {
    // 处理 401 和 403 错误（token过期或无效）
    if (error.response?.status === 401 || error.response?.status === 403) {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      localStorage.removeItem("username");
      localStorage.removeItem("nickname");
      // 清除token后跳转到登录页，并带提示参数
      // window.location.href = "/login?relogin=true";
    }
    return Promise.reject(error);
  }
);


// 导出
export default  $axios
